import React, { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import RankedQueryCard from "../../charts/RankedQueryCard";
import { signupsAndSubscriptionsQuery } from "../dashboard.queries";
import { buildSignupsByPlatform } from "../dashboard.utils";

import type { JSX } from "react";

import type { GetSignupsAndSubscriptionsResponse } from "@/src/api/StatsAPI.types";

import type { ChartSeries } from "../../charts/charts.types";
import type {
  DashboardPeriodProps,
  SignupsSeriesKey,
} from "../dashboard.types";

function SignupsByPlatformCard({ period }: DashboardPeriodProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");

  const seriesList = useMemo(
    (): ChartSeries<SignupsSeriesKey>[] => [
      {
        key: "signups",
        label: t("dashboard.series.signups"),
        color: "var(--chart-1)",
      },
    ],
    [t],
  );
  const buildRankedList = useCallback(
    (response: GetSignupsAndSubscriptionsResponse | undefined) =>
      buildSignupsByPlatform(response?.data ?? [], (platform) => t(platform)),
    [t],
  );

  return (
    <RankedQueryCard
      buildRankedList={buildRankedList}
      query={signupsAndSubscriptionsQuery(projectSlug, period)}
      seriesList={seriesList}
      title={t("dashboard.charts.signupsByPlatform")}
    />
  );
}

export default SignupsByPlatformCard;
